import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Timezones = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22 10C20.887 10 19.837 10.225 18.875 10.637C17.337 7.87402 14.375 5.99902 11 5.99902C6.037 5.99902 2 10.036 2 14.999C2 19.962 6.037 23.999 11 23.999C12.662 23.999 14.225 23.537 15.563 22.749C17.025 24.724 19.363 25.999 22.001 25.999C26.414 25.999 30.001 22.412 30.001 17.999C30.001 13.586 26.414 9.99902 22.001 9.99902L22 10ZM11 22C7.138 22 4 18.863 4 15C4 11.137 7.138 8.00002 11 8.00002C13.65 8.00002 15.95 9.47502 17.137 11.65C15.237 13.113 14 15.413 14 18C14 19.063 14.213 20.075 14.588 21C13.538 21.637 12.313 22 11 22ZM22 24C18.687 24 16 21.312 16 18C16 14.688 18.688 12 22 12C25.312 12 28 14.688 28 18C28 21.312 25.312 24 22 24Z" />
		<path d="M25 16H22C21.738 16 21.475 16.1 21.288 16.288L19.288 18.288C19.113 18.463 19 18.713 19 19C19 19.55 19.45 20 20 20C20.275 20 20.525 19.887 20.712 19.712L22.424 18H24.999C25.549 18 25.999 17.55 25.999 17C25.999 16.45 25.549 16 24.999 16H25Z" />
		<path d="M11 10C10.45 10 10 10.45 10 11V14.588L8.287 16.301C8.112 16.476 8 16.726 8 17.013C8 17.563 8.45 18.013 9 18.013C9.275 18.013 9.525 17.9 9.713 17.725L11.713 15.725C11.901 15.537 12 15.287 12 15.012V10.999C12 10.449 11.55 9.99902 11 9.99902V10Z" />
	</svg>
);

export default Timezones;
